import useSourceFlowCollection from "../hooks/useSourceFlowCollection";
import data from "../.sourceflow/jobs.json";

export const useJobs = ({
  limit = 10,
  regionFilters = null,
  sectorFilters = null,
  jobTypesFilters = null,
} = {}) => {

  // Apply Region filters
  let collection = useSourceFlowCollection(data.jobs).filter(function(job) {
    return (
      job.categories.find((cat) =>
          cat.id === "b4b8be3c-ba95-4912-aa85-2cbc1264449d" &&
          cat.values.find((x) => x.id === regionFilters)
      )
  )});

  // Apply Sector filters
  if (sectorFilters && sectorFilters.length > 0) {
    collection = collection.filter((job) => job?.categories.find((cat) => ["6201aa1d-bc28-452d-8f5c-9146fa604872", "e937d6f2-07a3-4ac7-bf04-0324eda2eee8"])?.values.some((filter) => sectorFilters?.includes(filter.id)));
  }
  
  // Apply Job Types filters
  if (jobTypesFilters && jobTypesFilters.length > 0) {
    collection = collection.filter((job) => job?.categories.find((cat) => cat.id === "87757283-767f-4224-85d3-986ac52dc4c5")?.values.some((filter) => jobTypesFilters?.includes(filter.id)));
  }

  // Apply limit
  if (limit) {
    return collection.slice(0, limit);
  }

  return collection;
};

export default useJobs;
